export default [
  {
    path: '/real-estate-developments-settings/credit-policies',
    name: 'CreditPoliciesList',
    component: () => import('pages/real-estate-developments-settings/credit-policies/CreditPoliciesList.vue')
  },
  {
    path: '/real-estate-developments-settings/credit-policies/new',
    name: 'CreditPoliciesCreate',
    component: () => import('pages/real-estate-developments-settings/credit-policies/CreditPoliciesForm.vue')
  },

  {
    path: '/real-estate-developments-settings/credit-policies/:id',
    name: 'CreditPoliciesSingleLayout',
    component: () => import('pages/real-estate-developments-settings/credit-policies/_layouts/CreditPoliciesSingleLayout.vue'),

    beforeEnter: (to, _, next) => {
      if (to.name === 'CreditPoliciesSingleLayout') {
        return next({ name: 'CreditPoliciesEdit', params: to.params })
      }

      next()
    },
    children: [
      {
        path: 'edit',
        name: 'CreditPoliciesEdit',
        meta: { slug: 'edit' },
        component: () => import('pages/real-estate-developments-settings/credit-policies/CreditPoliciesForm.vue')
      },
      {
        path: 'real-estate-developments',
        name: 'CreditPoliciesRealEstateDevelopments',
        meta: { slug: 'real-estate-developments' },
        component: () => import('pages/real-estate-developments-settings/credit-policies/tabs/CreditPoliciesRealEstateDevelopments.vue')
      },
      {
        path: 'facts',
        name: 'CreditPoliciesFactsList',
        meta: { slug: 'facts' },
        component: () => import('pages/real-estate-developments-settings/credit-policies/tabs/CreditPoliciesFactsList.vue')
      }
    ]
  }
]
